import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/common/ios-download-icon.svg")